import { useRef } from 'react';
import { useQueryClient } from 'react-query';
import { useConvertBettieEnergies } from '@pocapan/shared/domains/bettie/ui/hooks/useConvertBettieEnergies';
import { flyToTarget } from '../utils/flyToTarget';

export const useConvertEnergy = () => {
  const plusOneRef = useRef<HTMLParagraphElement | null>(null);
  const { mutateAsync: convertEnergy, isLoading: isConvertingEnergy } = useConvertBettieEnergies();
  const queryClient = useQueryClient();

  const handleConvertEnergy = async () => {
    try {
      const response = await convertEnergy();
      if (response) {
        await flyToTarget({
          text: '+1',
          fromEl: plusOneRef.current,
          toSelector: '[data-fly-target="free-charge-total-heart"]',
          durationMs: 1500,
          easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
          endScale: 0.6
        });
        queryClient.invalidateQueries(['bettieEnergies']);
        queryClient.invalidateQueries(['bettieBalances']);
      } else {
        throw new Error('Failed to convert energy');
      }
    } catch (error) {
      console.log(error);
    }
  };

  return {
    handleConvertEnergy,
    isConvertingEnergy,
    plusOneRef
  };
};
